const STAGE = process.env.STAGE; // eslint-disable-line prefer-destructuring

export const trackFacebookSale = ({ value }) => {
  if (STAGE === 'production') {
    if (window.fbq) {
      window.fbq('track', 'Purchase', {
        value,
        currency: 'USD',
      });
    }
  }
};

export const trackGoogleSale = ({ value, code, chargeUuid, slug }) => {
  if (STAGE === 'production') {
    if (window.gtag) {
      window.gtag('event', 'purchase', {
        value,
        currency: 'USD',
        coupon: code,
        transaction_id: chargeUuid,
        items: [
          {
            id: slug,
            name: slug,
            price: value,
            quantity: 1,
          },
        ],
      });

      window.gtag('event', 'conversion', {
        send_to: 'AW-847304068/32IfCNuukYoDEISrg5QD',
        transaction_id: chargeUuid,
        value,
        currency: 'USD',
      });
    }
  }
};

export const trackAffiliateSale = ({ price, chargeUuid, slug }) => {
  if (STAGE === 'production') {
    if (window.PostAffTracker) {
      const sale = window.PostAffTracker.createSale();
      sale.setTotalCost(price);
      sale.setOrderID(chargeUuid);
      sale.setProductID(slug);
      try {
        window.PostAffTracker.track();
      } catch (e) {
        /* NOP */
      }
    }
  }
};

export const trackRedditSale = () => {
  if (STAGE === 'production') {
    if (window.rdt) {
      rdt('track', 'Purchase');
    }
  }
};
